import { Component } from 'react';

// The one error screen; the two entry points below differ only in what
// "Try again" does. Both show it in place of Layout, so it carries the #main
// target of index.html's "Skip to content" link; inside Layout it would
// duplicate #main. Nothing catches errors above App, so keep it static: no
// hooks, no data.
function ErrorFallback({ onRetry }) {
  return (
    <div id="main" tabIndex={-1} role="alert" className="error-boundary">
      <div className="container error-boundary-inner">
        <span className="eyebrow">Something went wrong</span>
        <h1>This page hit a snag.</h1>
        <p>We had trouble loading this section. Try again, or head back home.</p>
        <div className="error-boundary-actions">
          <button type="button" className="btn" onClick={onRetry}>
            Try again
          </button>
          <a className="btn-ghost" href="/">
            Go home <span className="arrow">→</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined') {
      console.error('[ErrorBoundary]', error, info);
    }
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) return <ErrorFallback onRetry={this.reset} />;
    return this.props.children;
  }
}

function reloadPage() {
  window.location.reload();
}

// errorElement of the root route. The usual cause is a lazy page chunk that
// failed to load: after a deploy the old hashed file is gone, or the network
// dropped. React.lazy keeps the rejected import, so re-rendering can't recover;
// a full reload fetches the current index.html and its chunks. Keep this in the
// entry bundle: it has to render exactly when chunks can't be fetched.
export function RouteError() {
  return <ErrorFallback onRetry={reloadPage} />;
}
